import { STORE_ID, TYPES } from "./types";
import store from "../../index";

function dispatch(data) {
    data = { ...data, storeId: STORE_ID }
    store.dispatch(data);
}

export function setPermitions(value) {
    dispatch({
        type: TYPES.SET_PERMITIONS,
        value
    })
}

export function item(value) {
    dispatch({
        type: TYPES.CONVENIO,
        value
    });
}

export function copy(value) {
    dispatch({
        type: TYPES.CONVENIO_COPY,
        value
    });
}

export function setInvalid(field) {
    dispatch({
        type: TYPES.INVALID_CONVENIO,
        field
    });
}

export function getItems(value) {
    dispatch({
        type: TYPES.CONVENIOS_BANCO,
        value
    });
}

export function setBancos(value) {
    dispatch({
        type: TYPES.SET_BANCOS,
        value
    });
}

export function setConveniosRc(value) {
    dispatch({
        type: TYPES.SET_CONVENIOSRC,
        value
    });
}

export function cleanInvalid(field) {
    dispatch({
        type: TYPES.CLEAN_INVALID_CONVENIO,
        field
    })
}

export function cleanRegister() {
    dispatch({
        type: TYPES.CLEAN_REGISTER
    })
}

export function setActiveTab(value) {
    dispatch({
        type: TYPES.SET_ACTIVE_TAB,
        value
    })
}

export function setSeeRegister(value) {
    dispatch({
        type: TYPES.SET_SEE,
        value
    })
}
